export const DOBY_STATUS = {
  PENDING: "pending",
  REVIEW: "review",
  REJECT: "reject",
  CONFIRM: "confirm",
  CANCEL: "cancel",
};

export const DOBY_STATUS_MAPPING = {
  [DOBY_STATUS.PENDING]: "대기",
  [DOBY_STATUS.REVIEW]: "검토중",
  [DOBY_STATUS.REJECT]: "반려",
  [DOBY_STATUS.CONFIRM]: "승인",
  [DOBY_STATUS.CANCEL]: "취소",
};

export const DOBY_TYPE = {
  RENT: "rent",
  CONTRACT: "contract",
};

export const DOBY_PAYMENT_TYPE = {
  ONE_TIME: "one_time",
  MONTHLY: "monthly",
};

export const DOBY_FILE_TYPE = {
  CONTRACT: "contract",
};

export const DOBY_TRANSFER_STATUS = {
  SUCCESS: "송금완료",
  PENDING: "송금대기",
  FAIL: "송금실패",
  CANCEL: "송금취소",
};

export const DOBY_PAY_ORDER_STATUS = {
  PENDING: "결제대기",
  COMPLETED: "결제완료",
  FAILED: "결제실패",
  CANCELLED: "결제취소",
  REFUNDED: "결제환불",
};

export const DOBY_STATE = {
  UNREGISTERED: {
    key: "unregistered",
    rank: 1,
  },
  REJECTED: {
    key: "rejected",
    rank: 2,
  },
  REVIEWING: {
    key: "reviewing",
    rank: 3,
  },
  LIVE: {
    key: "live",
    rank: 4,
  },
  STOPPED_ONE_TIME: {
    key: "stopped_one_time",
    rank: 5,
  },
  CANCELLED_MONTHLY: {
    key: "cancelled_monthly",
    rank: 6,
  },
  CANCELLED_ONE_TIME: {
    key: "cancelled_one_time",
    rank: 7,
  },
};
